import { api } from '@api/api2';

const getRecords = (payload = null) =>
  api.no_vers('get', 'signal_notifications/get-signal-notification-categories', payload);

const getSignals = (payload) =>
  api.no_vers('get', 'signal_notifications/get-signals', {
    activ: 1, // Нужен для бэка интеграции
    ...payload,
  });

const exportSignals = (payload) =>
  api.no_vers(
    'request',
    'signal_notifications/get-signals',
    {
      ...payload,
      output: 'download',
      activ: 1,
    },
    {
      config: {
        responseType: 'arraybuffer',
      },
      method: 'get',
    }
  );

const getSignalsTypes = (payload) =>
  api.no_vers('get', 'signal_notifications/get-signal-notification-types', payload);

const setToOrFromArchive = (payload) =>
  api.no_vers('get', 'signal_notifications/update-signal-condition-map', payload);

export const recordsApi = {
  getRecords,
  getSignals,
  exportSignals,
  getSignalsTypes,
  setToOrFromArchive,
};
